import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  submit(event) {
    // Auto-submit the form when client selection changes
    const form = this.element
    const select = form.querySelector('select')
    
    // Only submit if a client is actually selected
    if (select.value && select.value !== '') {
      form.requestSubmit()
    }
  }

  handleSubmit(event) {
    // Add loading state to the select element
    const select = this.element.querySelector('select')
    if (select) {
      select.disabled = true
      select.classList.add('opacity-50', 'cursor-wait')
      
      // Re-enable after a delay (Turbo will handle the actual navigation)
      setTimeout(() => {
        select.disabled = false
        select.classList.remove('opacity-50', 'cursor-wait')
      }, 1000)
    }
  }
} 